import type { HeaderContent } from '@/blocks/domain/types/BlockContent/HeaderContent';
import type { BlockContentDto } from '@/blocks/application/mappers/blockMapper';
import { fieldsToDto, mapFieldsDto } from '@/blocks/application/mappers/blockFieldsMapper';

export function mapHeaderContent(dto: Extract<BlockContentDto, { kind: 'header' }>): HeaderContent {
  const content: HeaderContent = { kind: 'header', fields: mapFieldsDto(dto.fields ?? []) };
  if (dto.columns !== undefined) content.columns = dto.columns;
  if (dto.sections !== undefined) content.sections = dto.sections;
  return content;
}

export function fromHeaderContent(content: HeaderContent): Extract<BlockContentDto, { kind: 'header' }> {
  const dto: Extract<BlockContentDto, { kind: 'header' }> = { kind: 'header', fields: fieldsToDto(content.fields) };
  if (content.columns !== undefined) dto.columns = content.columns;
  if (content.sections !== undefined) dto.sections = content.sections;
  return dto;
}
